import React from "react";
import FeatureItem from "../components/FeatureItem";
import ServiceDescription from "../components/ServiceDescription";

const BackendDevelopmentServicesContent = () => {

	const features = [
		'API design and development',
		'Database management and optimization',
		'Big data architecture',
		'Content management systems',
	];

	return (
		<div className="card overflow-hidden">
			<div className="container p-5 space-lg-2">
				<div className="mx-md-auto">
					<div className="row justify-content-center align-items-md-center">
						<div className="col-md-5 mb-7 mb-md-0">
							{features.map(
								(item, index) =>
									<FeatureItem key={index} text={item} />
							)}
						</div>

						<div className="col-md-7 col-lg-5">
							<ServiceDescription
								description={'We put our extensive expertise into developing cloud-based back-end systems that can easily operate under heavy loads, process big data and scale without any latency issues.'}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BackendDevelopmentServicesContent;
